import { Autocomplete, FormControl, TextField } from "@mui/material";
import { supportedTimeZones, userTimeZone } from "../../../utils/time-zones";

import type { TextFieldProps } from "@mui/material";
import type { FC } from "react";

export type TimeZoneSelectorProps = Omit<TextFieldProps, "onChange" | "value"> & {
  value: string | null;
  onChangeTimeZone: (value: string | null) => void;
  targetChannel: boolean;
  disabled: boolean;
};

/** Select time zone */
export const TimeZoneSelector: FC<TimeZoneSelectorProps> = ({
  value,
  onChangeTimeZone,
  targetChannel,
  disabled,
  sx = [],
  ...textFieldProps
}) => {
  const recipientsTimeZone = "Recipients’ local time";

  const timeZone = value ? value : targetChannel ? userTimeZone() : recipientsTimeZone;

  return (
    <FormControl sx={{ minWidth: 270, ...sx }} disabled={disabled}>
      <Autocomplete
        id="time-zone-select"
        value={timeZone}
        disabled={disabled}
        disableClearable
        options={
          targetChannel ? supportedTimeZones() : [recipientsTimeZone, ...supportedTimeZones()]
        }
        groupBy={(tz) =>
          tz === recipientsTimeZone
            ? "Recipient-specific time zones"
            : "Location-specific time zones"
        }
        renderInput={(params) => <TextField {...params} {...textFieldProps} />}
        onChange={(event, v) => onChangeTimeZone(v === recipientsTimeZone ? null : v)}
      />
    </FormControl>
  );
};
